import { useState } from "react";
import { X } from "lucide-react";

const GALLERY = [
  {
    src: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&w=1200&q=85",
    caption: "Ivory Meadow · living room, Bengaluru",
    ratio: "aspect-[4/5]",
  },
  {
    src: "https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&w=1200&q=85",
    caption: "Sage Grove Runner · morning light",
    ratio: "aspect-[3/4]",
  },
  {
    src: "https://images.pexels.com/photos/29848182/pexels-photo-29848182.jpeg?auto=compress&cs=tinysrgb&w=1200",
    caption: "Loom in Bhadohi · March 2025",
    ratio: "aspect-[4/3]",
  },
  {
    src: "https://images.unsplash.com/photo-1582053628662-c65b0e0544e9?auto=format&fit=crop&w=1200&q=85",
    caption: "Teakwood Cascade Frame · studio wall",
    ratio: "aspect-square",
  },
  {
    src: "https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=1200&q=85",
    caption: "Terra Bloom Rug · reading nook",
    ratio: "aspect-[3/4]",
  },
  {
    src: "https://images.unsplash.com/photo-1705326701287-346fc37a2c86?auto=format&fit=crop&w=1200&q=85",
    caption: "A commission for a home in Copenhagen",
    ratio: "aspect-[4/5]",
  },
  {
    src: "https://images.unsplash.com/photo-1610384104075-e05c8cf200c3?auto=format&fit=crop&w=1200&q=85",
    caption: "Little Nest baskets · a child's room",
    ratio: "aspect-square",
  },
  {
    src: "https://images.pexels.com/photos/37877827/pexels-photo-37877827.jpeg?auto=compress&cs=tinysrgb&w=1200",
    caption: "Vegetable-dye kitchen · Rajasthan",
    ratio: "aspect-[4/5]",
  },
  {
    src: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=85",
    caption: "Linen Field · a Sunday afternoon",
    ratio: "aspect-[3/4]",
  },
];

export default function Gallery() {
  const [preview, setPreview] = useState(null);

  return (
    <div data-testid="gallery-page">
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 pt-16 md:pt-24 pb-12">
        <div className="overline">The Gallery</div>
        <h1 className="mt-4 font-serif text-5xl md:text-6xl lg:text-7xl font-light text-[#1B3B36] leading-[1.02] tracking-tight max-w-4xl">
          Iryaa <em className="italic text-[#84968C]">in the wild.</em>
        </h1>
        <p className="mt-8 text-[16px] leading-relaxed text-[#4A4A4A] font-light max-w-2xl">
          Fragments from the loom, from our clients' homes, and from the small
          Indian towns where our craft lives. Click any image to view.
        </p>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 pb-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6">
          {GALLERY.map((g, i) => (
            <button
              key={i}
              data-testid={`gallery-tile-${i}`}
              onClick={() => setPreview(g)}
              className={`mb-6 relative w-full ${g.ratio} overflow-hidden group hover-view break-inside-avoid`}
            >
              <img
                src={g.src}
                alt={g.caption}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B3B36]/40 via-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-4 left-4 right-4 text-left opacity-0 group-hover:opacity-100 transition-opacity text-[#F9F8F6] font-serif text-lg leading-tight">
                {g.caption}
              </div>
            </button>
          ))}
        </div>
      </section>

      {preview && (
        <div
          data-testid="gallery-preview"
          className="fixed inset-0 z-50 bg-[#1B3B36]/95 backdrop-blur flex items-center justify-center p-6"
          onClick={() => setPreview(null)}
        >
          <button
            data-testid="gallery-preview-close"
            className="absolute top-6 right-6 text-[#F9F8F6]"
            onClick={() => setPreview(null)}
          >
            <X size={22} />
          </button>
          <figure
            className="max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={preview.src}
              alt={preview.caption}
              className="w-full max-h-[80vh] object-contain"
            />
            <figcaption className="mt-4 text-center text-[#F9F8F6] font-serif text-2xl">
              {preview.caption}
            </figcaption>
          </figure>
        </div>
      )}
    </div>
  );
}
